import styled from '@emotion/styled';
import { useMediaQuery } from '@material-ui/core';
import { createElement, FC, Fragment } from 'react';

import theme from '../../../theme';
import mq from '../../styleUtility/mediaquery';

type Props = {
  className?: string;
};

const DirectionTypeOtherPanel: FC<Props> = (props) => {
  const isPC = useMediaQuery(`(min-width:${theme.breakpoints.values['lg']}px)`);
  return (
    <>
      <PCImage width={isPC ? 357 : 450} height={isPC ? 363 : 457} {...props}>
        <g data-name="\u30B0\u30EB\u30FC\u30D7 493" transform={isPC ? 'translate(-771 -275)' : 'translate(-780 -220)'}>
          <rect
            data-name="\u9577\u65B9\u5F62 914"
            width={357}
            height={224}
            rx={8}
            transform="translate(771 275)"
            fill="#f5f5f5"
          />
          <text
            data-name="etc\u2026"
            transform="translate(936 468)"
            fill="#4c566c"
            fontSize={14}
            fontFamily="Lato-Bold, Lato"
            fontWeight={700}
          >
            <tspan x={0} y={0}>
              {'etc\u2026'}
            </tspan>
          </text>
          <g data-name="\u30B0\u30EB\u30FC\u30D7 418">
            <path
              data-name="\u30D1\u30B9 1110"
              d="M1094.445 401.182h-69.365l-1.08-1.08V303.08l1.08-1.08h69.365l1.08 1.08v97.022zm-68.289-2.159h67.209V304.16h-67.206z"
              fill="#4c566c"
            />
            <path
              data-name="\u30D1\u30B9 1111"
              d="M1100.421 406.489h-69.369a1.08 1.08 0 010-2.159h68.289v-95.941a1.08 1.08 0 112.159 0v97.022z"
              fill="#4c566c"
            />
            <path
              data-name="\u30D1\u30B9 1112"
              d="M1084.727 313.513h-51.809a.54.54 0 110-1.08h51.809a.54.54 0 110 1.08z"
              fill="#4c566c"
            />
            <path
              data-name="\u30D1\u30B9 1113"
              d="M1084.727 319.195h-51.809a.54.54 0 110-1.08h51.809a.54.54 0 110 1.08z"
              fill="#4c566c"
            />
            <path
              data-name="\u30D1\u30B9 1114"
              d="M1084.727 324.878h-51.809a.54.54 0 110-1.08h51.809a.54.54 0 110 1.08z"
              fill="#4c566c"
            />
            <path
              data-name="\u30D1\u30B9 1115"
              d="M1087.155 349.673h-17.195a.54.54 0 010-1.08h17.195a.54.54 0 010 1.08z"
              fill="#4c566c"
            />
            <path
              data-name="\u30D1\u30B9 1116"
              d="M1087.155 355.355h-17.195a.54.54 0 110-1.08h17.195a.54.54 0 010 1.08z"
              fill="#4c566c"
            />
            <path
              data-name="\u30D1\u30B9 1117"
              d="M1087.155 361.04h-17.195a.54.54 0 110-1.08h17.195a.54.54 0 010 1.08z"
              fill="#4c566c"
            />
            <path
              data-name="\u30D1\u30B9 1118"
              d="M1084.727 330.328h-51.809a.54.54 0 110-1.08h51.809a.54.54 0 110 1.08z"
              fill="#4c566c"
            />
            <path
              data-name="\u30D1\u30B9 1119"
              d="M1084.727 336.009h-51.809a.54.54 0 110-1.08h51.809a.54.54 0 110 1.08z"
              fill="#4c566c"
            />
            <path
              data-name="\u30D1\u30B9 1120"
              d="M1066.568 341.692h-33.65a.54.54 0 010-1.08h33.649a.54.54 0 110 1.08z"
              fill="#4c566c"
            />
            <g data-name="\u30B0\u30EB\u30FC\u30D7 410">
              <path
                data-name="\u30D1\u30B9 1121"
                d="M1050.743 368.379h16.652a17.146 17.146 0 00-16.652-16.06z"
                fill="#5783a4"
              />
              <path
                data-name="\u30D1\u30B9 1122"
                d="M1048.583 370.538v-18.146a17.15 17.15 0 1018.809 18.146z"
                fill="#f0de4e"
              />
            </g>
          </g>
          <g data-name="\u30B0\u30EB\u30FC\u30D7 419">
            <path
              data-name="\u9577\u65B9\u5F62 904"
              fill="#4487bb"
              stroke="#22232a"
              d="M917.305 364.262h25.602v31.51h-25.602z"
            />
            <path
              data-name="\u9577\u65B9\u5F62 905"
              fill="#5783a4"
              stroke="#0c2540"
              d="M963.253 338.217h16.617v20.452h-16.617z"
            />
            <path
              data-name="\u30D1\u30B9 1149"
              d="M953.834 340.131h-35.435a.6.6 0 010-1.2h35.435a.6.6 0 110 1.2z"
              fill="#4c566c"
            />
            <path
              data-name="\u30D1\u30B9 1150"
              d="M953.834 346.432h-35.435a.6.6 0 010-1.2h35.435a.6.6 0 110 1.2z"
              fill="#4c566c"
            />
            <path
              data-name="\u30D1\u30B9 1151"
              d="M953.834 352.735h-35.435a.6.6 0 010-1.2h35.435a.6.6 0 110 1.2z"
              fill="#4c566c"
            />
            <path
              data-name="\u30D1\u30B9 1152"
              d="M942.592 400.232h-25.128a.6.6 0 010-1.2h25.128a.6.6 0 010 1.2z"
              fill="#4c566c"
            />
            <path
              data-name="\u30D1\u30B9 1153"
              d="M935.674 404.535h-18.21a.6.6 0 010-1.2h18.209a.6.6 0 010 1.2z"
              fill="#4c566c"
            />
            <path
              data-name="\u9577\u65B9\u5F62 906"
              fill="#8dafcc"
              stroke="#22232a"
              d="M954.058 364.262h25.602v31.51h-25.602z"
            />
            <path
              data-name="\u30D1\u30B9 1154"
              d="M979.344 400.232h-25.127a.6.6 0 010-1.2h25.127a.6.6 0 010 1.2z"
              fill="#4c566c"
            />
            <path
              data-name="\u30D1\u30B9 1155"
              d="M972.427 404.535h-18.21a.6.6 0 010-1.2h18.209a.6.6 0 010 1.2z"
              fill="#4c566c"
            />
            <path
              data-name="\u30D1\u30B9 1156"
              d="M911.198 304.197v9.148h76.678v-9.148zm65.881 6.163a2.139 2.139 0 112.14-2.139 2.139 2.139 0 01-2.143 2.139zm5.789 0a2.139 2.139 0 112.139-2.139 2.139 2.139 0 01-2.139 2.139z"
              fill="#b5b7b9"
            />
            <path
              data-name="\u9577\u65B9\u5F62 907"
              fill="#f0de4e"
              stroke="#0c2540"
              d="M917.514 318.176h63.128v13.404h-63.128z"
            />
            <path
              data-name="\u30D1\u30B9 1148"
              d="M988.134 412h-76.938l-1.2-1.2V303.197l1.2-1.2h76.936l1.2 1.2v107.606zm-75.738-2.395h74.541V304.396h-74.541z"
              fill="#4c566c"
            />
          </g>
          <circle
            data-name="\u6955\u5186\u5F62 468"
            cx={24.5}
            cy={24.5}
            r={24.5}
            transform="translate(925 474)"
            fill="#fff"
          />
          <path
            id="パス_1267"
            data-name="パス 1267"
            d="M7.8-23.5,23.5-39.2,39.2-23.5l-2.846,2.754L25.428-31.67V-7.8H21.572V-31.67L10.557-20.746Z"
            transform="translate(973 472) rotate(180)"
            fill="#f0de4e"
          />
          <path
            d="M898.5 523v92.859h101.3V523zm16.883 84.417h-8.441v-8.441h8.442zm0-16.883h-8.441v-8.442h8.442zm0-16.883h-8.441v-8.442h8.442zm0-16.883h-8.441v-8.443h8.442zm0-16.883h-8.441v-8.443h8.442zm59.092 50.65h-50.65v-42.21h50.65zm16.884 16.882h-8.442v-8.441h8.442zm0-16.883h-8.442v-8.442h8.442zm0-16.883h-8.442v-8.442h8.442zm0-16.883h-8.442v-8.443h8.442zm0-16.883h-8.442v-8.443h8.442zm-50.65 42.207v-25.325l21.1 12.663z"
            fill="#4487bb"
            stroke="#2d445a"
            strokeWidth={2}
          />
          <g data-name="\u30B0\u30EB\u30FC\u30D7 438" transform="translate(-7 13)">
            <rect
              data-name="\u9577\u65B9\u5F62 916"
              width={83}
              height={24}
              rx={12}
              transform="translate(800 417)"
              fill="#f0de4e"
            />
            <text
              transform="translate(821 434)"
              fill="#4c566c"
              fontSize={14}
              fontFamily="HiraginoSans-W6, Hiragino Sans"
            >
              <tspan x={0} y={0}>
                {'\u30C1\u30E9\u30B7'}
              </tspan>
            </text>
          </g>
          <text transform="translate(930 636)" fill="#4c566c" fontSize={14} fontFamily="HiraginoSans-W6, Hiragino Sans">
            <tspan x={0} y={0}>
              {'\u52D5\u753B\u5316'}
            </tspan>
          </text>
          <g data-name="\u30B0\u30EB\u30FC\u30D7 437" transform="translate(-10 13)">
            <rect
              data-name="\u9577\u65B9\u5F62 917"
              width={83}
              height={24}
              rx={12}
              transform="translate(918 417)"
              fill="#f0de4e"
            />
            <text
              transform="translate(952 434)"
              fill="#4c566c"
              fontSize={14}
              fontFamily="Lato-Bold, Lato"
              fontWeight={700}
            >
              <tspan x={0} y={0}>
                {'LP'}
              </tspan>
            </text>
          </g>
          <g data-name="\u30B0\u30EB\u30FC\u30D7 436" transform="translate(-13 13)">
            <rect
              data-name="\u9577\u65B9\u5F62 918"
              width={83}
              height={24}
              rx={12}
              transform="translate(1032 417)"
              fill="#f0de4e"
            />
            <text
              transform="translate(1060 434)"
              fill="#4c566c"
              fontSize={14}
              fontFamily="HiraginoSans-W6, Hiragino Sans"
            >
              <tspan x={0} y={0}>
                {'\u8CC7\u6599'}
              </tspan>
            </text>
          </g>
          <g data-name="\u30B0\u30EB\u30FC\u30D7 440">
            <g data-name="\u30B0\u30EB\u30FC\u30D7 417">
              <path
                data-name="\u30D1\u30B9 1130"
                d="M857.377 368.146h-71.62l-.757-.758v-60.631l.757-.757h71.62l.757.757v60.631zm-70.862-1.519h70.108v-59.112h-70.108z"
                fill="#4c566c"
              />
              <path
                data-name="\u9577\u65B9\u5F62 899"
                fill="#82a7d2"
                stroke="#0c2540"
                d="M789.073 329.489h16.193v19.93h-16.193z"
              />
              <path
                data-name="\u9577\u65B9\u5F62 900"
                fill="#81a7d3"
                stroke="#0c2540"
                d="M809.003 329.489h16.193v19.93h-16.193z"
              />
              <path
                data-name="\u30D1\u30B9 1134"
                d="M853.346 330.615h-24.663a.379.379 0 110-.757h24.663a.379.379 0 110 .757z"
                fill="#4c566c"
              />
              <path
                data-name="\u30D1\u30B9 1135"
                d="M853.346 334.6h-24.663a.379.379 0 110-.757h24.663a.379.379 0 110 .757z"
                fill="#4c566c"
              />
              <path
                data-name="\u30D1\u30B9 1136"
                d="M853.346 338.586h-24.663a.379.379 0 110-.757h24.663a.379.379 0 110 .757z"
                fill="#4c566c"
              />
              <path
                data-name="\u30D1\u30B9 1137"
                d="M853.346 342.572h-24.663a.379.379 0 110-.757h24.663a.379.379 0 110 .757z"
                fill="#4c566c"
              />
              <path
                data-name="\u30D1\u30B9 1138"
                d="M853.346 346.309h-24.663a.379.379 0 110-.757h24.663a.379.379 0 110 .757z"
                fill="#4c566c"
              />
              <path
                data-name="\u9577\u65B9\u5F62 901"
                fill="#4889b9"
                stroke="#0c2540"
                d="M811.494 352.412h10.51v11.936h-10.51z"
              />
              <path
                data-name="\u30D1\u30B9 1139"
                d="M831.673 352.786h-7.723a.379.379 0 110-.757h7.723a.379.379 0 110 .757z"
                fill="#4c566c"
              />
              <path
                data-name="\u30D1\u30B9 1140"
                d="M831.673 356.772h-7.723a.379.379 0 110-.757h7.723a.379.379 0 110 .757z"
                fill="#4c566c"
              />
              <path
                data-name="\u30D1\u30B9 1141"
                d="M831.673 360.758h-7.723a.379.379 0 110-.757h7.723a.379.379 0 110 .757z"
                fill="#4c566c"
              />
              <path
                data-name="\u9577\u65B9\u5F62 902"
                fill="#4787b2"
                stroke="#0c2540"
                d="M789.572 352.412h10.51v11.936h-10.51z"
              />
              <path
                data-name="\u30D1\u30B9 1142"
                d="M809.75 352.786h-7.723a.379.379 0 010-.757h7.723a.379.379 0 110 .757z"
                fill="#4c566c"
              />
              <path
                data-name="\u30D1\u30B9 1143"
                d="M809.75 356.772h-7.723a.379.379 0 010-.757h7.723a.379.379 0 110 .757z"
                fill="#4c566c"
              />
              <path
                data-name="\u30D1\u30B9 1144"
                d="M809.75 360.758h-7.723a.379.379 0 010-.757h7.723a.379.379 0 110 .757z"
                fill="#4c566c"
              />
              <path
                data-name="\u9577\u65B9\u5F62 903"
                fill="#4a8ab3"
                stroke="#0c2540"
                d="M834.164 352.412h10.51v11.936h-10.51z"
              />
              <path
                data-name="\u30D1\u30B9 1145"
                d="M854.34 352.786h-7.72a.379.379 0 110-.757h7.72a.379.379 0 110 .757z"
                fill="#4c566c"
              />
              <path
                data-name="\u30D1\u30B9 1146"
                d="M854.34 356.772h-7.72a.379.379 0 110-.757h7.72a.379.379 0 110 .757z"
                fill="#4c566c"
              />
              <path
                data-name="\u30D1\u30B9 1147"
                d="M854.34 360.758h-7.72a.379.379 0 110-.757h7.72a.379.379 0 110 .757z"
                fill="#4c566c"
              />
              <g data-name="\u9577\u65B9\u5F62 912" fill="#4487bb" stroke="#22232a">
                <path stroke="none" d="M789.138 310h65v16h-65z" />
                <path fill="none" d="M789.638 310.5h64v15h-64z" />
              </g>
              <g data-name="\u30B0\u30EB\u30FC\u30D7 414" fill="#f2dc4e">
                <path
                  data-name="\u30D1\u30B9 1131"
                  d="M809.174 315.449a1.478 1.478 0 00-1.312.677 3.067 3.067 0 000 2.992 1.61 1.61 0 002.623 0 3.071 3.071 0 000-2.992 1.478 1.478 0 00-1.311-.677z"
                />
                <path
                  data-name="\u30D1\u30B9 1132"
                  d="M816.75 315.516h-1.281v1.875h1.281q1.025 0 1.025-.912 0-.963-1.025-.963z"
                />
                <path
                  data-name="\u30D1\u30B9 1133"
                  d="M790.318 311.054v13.9h62.841v-13.9zm44.268 2.981h1.739v1.776l-.457 3.02h-.825l-.457-3.02zm-22.851 6.231a3.619 3.619 0 01-5.165 0 4.3 4.3 0 010-5.3 3.618 3.618 0 015.165 0 4.3 4.3 0 010 5.3zm5.283-1.455h-1.519v2.387h-1.847v-7.163h3.367a2.828 2.828 0 011.778.522 2.111 2.111 0 01.784 1.786q-.001 2.468-2.563 2.468zm9.186 2.387h-5.75v-7.163h5.651v1.5h-3.8v1.254h3.469v1.436h-3.476v1.364h3.9zm7.151 0h-1.906l-2.475-4.463v4.464h-1.738v-7.164h1.905l2.474 4.415v-4.415h1.738zm3.019 0h-1.847v-1.866h1.847z"
                />
              </g>
            </g>
            <g data-name="\u30B0\u30EB\u30FC\u30D7 439">
              <path data-name="\u9577\u65B9\u5F62 919" fill="#f5f5f5" d="M846.138 352h37v3h-37z" />
              <g data-name="\u30B0\u30EB\u30FC\u30D7 422">
                <path data-name="\u30D1\u30B9 1157" d="M841.827 354.341V408h41.2l-.047-56.039" fill="#fff" />
                <g data-name="\u30B0\u30EB\u30FC\u30D7 421" stroke="#22232a">
                  <path data-name="\u30D1\u30B9 1158" d="M882.979 351.961L846.825 344v7.961z" fill="#7cabcf" />
                  <path
                    data-name="\u30D1\u30B9 1159"
                    d="M841.827 354.342v53.659h41.2v-53.659zm28.793 38.161h-21.7v-2.38h21.7zm-21.7-6.425v-2.379h14.2v2.379zm27.407-10.076h-27.804v-12.85h27.806z"
                    fill="#7cabcf"
                  />
                  <g data-name="\u30B0\u30EB\u30FC\u30D7 420" fill="#eddc4a">
                    <path
                      data-name="\u30D1\u30B9 1160"
                      d="M852.527 374.152v-9.153h3.588a4.223 4.223 0 014.336 4.575 4.706 4.706 0 01-1.2 3.345 4.188 4.188 0 01-3.113 1.231zm3.393-2.121c1.385 0 2.179-.895 2.179-2.454 0-1.582-.782-2.453-2.2-2.453h-.949v4.907z"
                    />
                    <path
                      data-name="\u30D1\u30B9 1161"
                      d="M864.742 368.198l1.493 5.942h2.546l1.493-5.942v5.942h2.051v-9.142h-3.3l-1.515 6.028-1.515-6.028h-3.3v9.139h2.052z"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </PCImage>
      <SPImage src="/assets/directionTypeOtherPanel.png" />
    </>
  );
};

const PCImage = styled('svg')({
  [mq('sp')]: {
    transform: 'scale(0.75)',
  },
});

const SPImage = styled('img')({
  display: 'none',
});

export default DirectionTypeOtherPanel;
